<template>
<div>
  <New :schemas="schemas" v-on:created="created($event)" />
  <v-container fluid grid-list-md>
    <v-app id="inspire">
      <v-container fluid grid-list-md>
        <v-progress-linear v-if="loading" :indeterminate="true">
        </v-progress-linear>

        <div v-else>
          <v-data-iterator :items="dirsView" :pagination.sync="pagination" :rows-per-page-items="[4,8,12]" content-tag="v-layout" row wrap>
            <template v-slot:item="props">
              <v-flex xs12 sm6 md4 lg3>
                <DirView :schemas="schemas" v-on:delete="deleteDir($event)" v-on:updated="update($event)" :dirView="props.item" />
              </v-flex>
            </template>
          </v-data-iterator>
        </div>
      </v-container>
    </v-app>
  </v-container>

</div>
</template>
<script>
import http from '@/plugins/http'
import New from './New'
import DirView from './DirView'
export default {
  components: {
    New,
    DirView
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 12
      },
      name: "",
      loading: false,
      dirsView: [],
      schemas: []
    }
  },
  methods: {
    created(schema) {
      this.dirsView.push(schema)
    },
    update(dir) {
      let dirOrg = this.dirsView.find(el => el.id == dir.id)
      dirOrg.name = dir.name
      dirOrg.schemas = dir.schemas
    },
    deleteDir(dir) {
      http.delete("dir-view/" + dir.id).then(() => {
        this.dirsView = this.dirsView.filter(el => el.id != dir.id)
      })
    },
    loadSchema() {
      http.get('schemas').then(data => {
        this.schemas = data.data
      })
    },
  },
  created() {
    http.get("dir-view")
      .then(data => this.dirsView = data.data)
      .catch(() => null)
    this.loadSchema()
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.filtr-active {
  background-color: green !important;
}
</style>
